import { useCallback, useState } from "react";
import { colorLineGraph, getMonthName } from "../../../../helpers/generalHelper";
import { getRequestGraphSemaforo } from "../../../../config";

const statusOrder = ["verde", "amarillo", "super_rojo", "rojo", "morado"];
const translatedStatuses = {
    "super_rojo": "Peligroso",
    "morado": "Desbordado",
    "verde": "Satisfactorio",
    "amarillo": "Ideal",
    "rojo": "Excedido",
}


const compareStatus = (a, b) => {
    return statusOrder.indexOf(a.id) - statusOrder.indexOf(b.id);
};

const useSemaforo = () => {
    const [projectsList, setProjectsList] = useState([]);
    const [statusProjectList, setStatusProjectList] = useState([]);
    const [status, setStatus] = useState({ verde: 0, amarillo: 0, super_rojo: 0, rojo: 0, morado: 0 });

    const updateSemaforo = useCallback(async (year) => {
        const { payload } = await getRequestGraphSemaforo(year);
        const { entries, allStatus } = payload;
        const data = {};
        entries.forEach((entry) => {
            const { _id: status, projects } = entry;
            const { color, indexColor } = colorLineGraph(status);
            data[status] = {
                id: translatedStatuses[status],
                color,
                indexColor,
            };

            const base = Array.from({ length: 12 }, (_, index) => index + 1).reduce((prev, current) => {
                const monthName = getMonthName(current);
                prev[current] = {
                    x: monthName,
                    y: 0
                }
                return prev;
            }, {});
            projects.forEach((project) => {
                const { month } = project;
                const monthName = getMonthName(month);
                if (!data[status].hasOwnProperty('data')) {

                    const copyAllMonths = JSON.parse(JSON.stringify(base));

                    copyAllMonths[month].y = 1;
                    copyAllMonths[month].status = project.status;
                    copyAllMonths[month].indexMonth = month;
                    data[status].data = Object.values(copyAllMonths);
                    return;
                }
                const index = data[status].data.findIndex((item) => item.x === monthName);
                if (index === -1) return alert("veamos")
                data[status].data[index].y += 1;
                data[status].data[index].status = project.status;
            });
        });

        const orderedData = Object.values(data).sort(compareStatus);
        setStatus(allStatus);
        setProjectsList(orderedData);
        setStatusProjectList(orderedData);
    }, []);

    const updateProjectStatus = useCallback(
        (status) => {
            if (status === "TODOS") return setStatusProjectList(projectsList);
            const newProjects = projectsList.map((progressStatus) => {
                const newStatus = progressStatus.data.map((project) => {
                    if (!project.status) return { ...project, y: 0 };
                    return { ...project, y: project.status === status ? project.y : 0 }
                });
                return {
                    ...progressStatus,
                    data: newStatus,

                };
            });
            setStatusProjectList(newProjects);
        },
        [projectsList]
    );

    return { updateSemaforo, projectsList, status, statusProjectList, updateProjectStatus };
};

export default useSemaforo;
